import { getSnappedMousePosition } from '@/domain/dienstplan/features/VisualEditor/hooks/useVisualEditor/actions/utils/getSnappedMousePosition';
import { SharedContext } from '@/domain/dienstplan/features/VisualEditor/hooks/useVisualEditor/types';
import { Point } from '@/domain/dienstplan/features/VisualEditor/types';
import { isMouseInInterval } from '@/domain/dienstplan/features/VisualEditor/utils/mouseHelper/isMouseInInterval';
import {
  Belegung,
  BelegungsIntervall,
} from '@/domain/dienstplan/shared/types/Belegung';
import { Weekday } from '@/domain/dienstplan/shared/types/Weekday';

export function startBelegungCreate({
  ctx,
  currentPoint,
}: {
  currentPoint: Point;
  ctx: SharedContext;
}) {
  const { x, y } = getSnappedMousePosition(ctx, currentPoint);
  const currentBelegungen = getBelegungenForSelectedBereich(ctx);
  const {
    store: { addBelegung, setStartBelegungPosition, setIsCreatingNewBelegung },
  } = ctx;

  if (isClickInsideExistingInterval(currentBelegungen, { x, y })) {
    return;
  }

  const newBelegung = createNewBelegung(ctx, { x, y });
  const activeInterval = new BelegungsIntervall(newBelegung, 'active');

  addBelegung(activeInterval);
  setStartBelegungPosition({ x, y });
  setIsCreatingNewBelegung(true);
}

function getBelegungenForSelectedBereich(ctx: SharedContext) {
  return ctx.belegungen
    .filter((b) => b.mode === 'inactive')
    .filter(
      (b) => b.belegung.arbeitsbereich.id === ctx.selectedArbeitsbereich.id,
    );
}

function isClickInsideExistingInterval(
  belegungen: BelegungsIntervall[],
  point: Point,
) {
  return isMouseInInterval(belegungen, point);
}

function createNewBelegung(ctx: SharedContext, { x, y }: Point) {
  return new Belegung({
    id: crypto.randomUUID(),
    tag: ctx.weekday as Weekday,
    start: x,
    ende: x,
    personenanzahlMin: 0,
    personenanzahlMax: y,
    arbeitsbereich: ctx.selectedArbeitsbereich,
  });
}
